var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons8-instagram","transform":"translate(-5 -5)"},[React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M24.2,5H13.332A8.342,8.342,0,0,0,5,13.332V24.2a8.342,8.342,0,0,0,8.332,8.332H24.2A8.342,8.342,0,0,0,32.533,24.2V13.332A8.342,8.342,0,0,0,24.2,5ZM18.767,26.012a7.246,7.246,0,1,1,7.246-7.246A7.254,7.254,0,0,1,18.767,26.012ZM26.012,12.97a1.449,1.449,0,1,1,1.449-1.449A1.449,1.449,0,0,1,26.012,12.97Z","fill":"#979797","key":0}),React.createElement("circle",{"id":"Ellipse_1","data-name":"Ellipse 1","cx":"6","cy":"6","r":"6","transform":"translate(13 13)","fill":"#979797","key":1})]));
}

Instagram.defaultProps = {"width":"27.533","height":"27.533","viewBox":"0 0 27.533 27.533"};

module.exports = Instagram;

Instagram.default = Instagram;
